/**
 * @description javascript related to downloading pdf/files without opening another tab
 */

/**
 * @descripiton kick off download module
 */
const init = () => {
  bindEvents();
}

/**
 * @description bind events for any links with data-download-link to download file without opening a tab.
 */
const bindEvents = () => {
  const downloadLinks = document.querySelectorAll("[data-download-link]")
  downloadLinks.forEach( downloadLink => {
    const linkpath  = downloadLink.dataset.downloadLink;
    const fileName = linkpath.substr(linkpath.lastIndexOf('/') + 1, linkpath[linkpath.length]);
    downloadLink.addEventListener('click', () => {
      download(linkpath, fileName);
    })
  });
}

/**
 * @description download the file.
 */
const download = (url, filename)  => {
  fetch(url).then(function(t) {
      return t.blob().then((b)=>{
          const a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", filename);
          a.click();
      });
  });
}

export default init;